angular
    .module('vm')
    .component('appAlerts', {
        templateUrl: 'alerts.component.html',
        bindings: {
            heightChange: '&',
        },
        controllerAs: 'vm',
        controller: function (AlertsService, $element, $timeout) {
            const vm = this;

            vm.alerts = [];

            vm.$onInit = $onInit;
            vm.$onDestroy = $onDestroy;
            vm.removeAlert = removeAlert;

            ///////////

            function $onInit() {
                vm.alerts = AlertsService.getAlerts();
                AlertsService.subscribe(onAlertsUpdate);
                updateContainerHeight();
            }

            function $onDestroy() {
                AlertsService.unsubscribe(onAlertsUpdate);
            }

            function onAlertsUpdate(alerts) {
                vm.alerts = alerts;
                updateContainerHeight();
            }

            function updateContainerHeight() {
                $timeout(() => {
                    const height = $element[0].offsetHeight;
                    // vm.heightChange(height);
                }, 100);
            }

            function removeAlert(alert) {
                AlertsService.remove(alert);
            }
        }
    })
;